import React from "react";
import { Minus, Plus } from "lucide-react";
import DeliveryHoursCalc from "./DeliveryHoursCalc";
import DeliveryTimeDayTypes from "./DeliveryTimeDayTypes";
import { useSelector, useDispatch } from "react-redux";
import * as actionType from "../../../store/action";

const DeliveryEdit = () => {
  const regulaerDeliveryPrice = useSelector(
    (state) => state.productsInCart.regulaerDeliveryPrice,
  );
  const orderForFree = useSelector(
    (state) => state.productsInCart.orderForFree,
  );
  const dispatch = useDispatch();

  const changeDeliveryPrice = (amount) => {
    dispatch({
      type: actionType.SET_DELIVERY_PRICE,
      payload: { deliveryAvailable: true, deliveryPrice: amount },
    });
  };

  const changeOrderForFree = (amount) => {
    dispatch({ type: actionType.SET_ORDER_FOR_FREE, payload: amount });
  };

  const handleDeliveryPriceInputChange = (event) => {
    const newValue = parseFloat(event.target.value);
    if (!isNaN(newValue)) {
      changeDeliveryPrice(newValue);
    }
  };

  const handleOrderForFreeInputChange = (event) => {
    const newValue = parseFloat(event.target.value);
    if (!isNaN(newValue)) {
      changeOrderForFree(newValue);
    }
  };

  return (
    <div className="delivery-time-edit admin-page admin-page--fill">
      <header className="admin-page__header">
        <div className="admin-page__header-start">
          <h1 className="title-role">עריכת זמני משלוח</h1>
        </div>
      </header>
      <div className="admin-page__toolbar delivery-settings-bar">
        <span className="delivery-settings-bar__label">דמי משלוח:</span>
        <div className="price-control">
          <button
            type="button"
            className="admin-icon-btn"
            onClick={() => changeDeliveryPrice(regulaerDeliveryPrice - 1)}
            title="הפחת דמי משלוח"
            aria-label="הפחת דמי משלוח"
          >
            <Minus aria-hidden size={16} strokeWidth={2} />
          </button>
          <input
            type="number"
            className="price-input"
            value={regulaerDeliveryPrice}
            onChange={handleDeliveryPriceInputChange}
          />
          <button
            type="button"
            className="admin-icon-btn"
            onClick={() => changeDeliveryPrice(regulaerDeliveryPrice + 1)}
            title="הוסף דמי משלוח"
            aria-label="הוסף דמי משלוח"
          >
            <Plus aria-hidden size={16} strokeWidth={2} />
          </button>
          <span>₪</span>
        </div>
        <span className="delivery-settings-bar__divider" aria-hidden>
          |
        </span>
        <span className="delivery-settings-bar__label">הזמנה למשלוח חינם:</span>
        <div className="price-control">
          <button
            type="button"
            className="admin-icon-btn"
            onClick={() => changeOrderForFree(orderForFree - 1)}
            title="הפחת סף משלוח חינם"
            aria-label="הפחת סף משלוח חינם"
          >
            <Minus aria-hidden size={16} strokeWidth={2} />
          </button>
          <input
            type="number"
            className="price-input"
            value={orderForFree}
            onChange={handleOrderForFreeInputChange}
          />
          <button
            type="button"
            className="admin-icon-btn"
            onClick={() => changeOrderForFree(orderForFree + 1)}
            title="הוסף סף משלוח חינם"
            aria-label="הוסף סף משלוח חינם"
          >
            <Plus aria-hidden size={16} strokeWidth={2} />
          </button>
          <span>₪</span>
        </div>
      </div>
      <div className="admin-page__body">
        <DeliveryHoursCalc />
        <DeliveryTimeDayTypes />
      </div>
    </div>
  );
};

export default DeliveryEdit;
